import gql from 'graphql-tag';

import conversationFragment from './conversationFragment';
import dokkioTagFragment from './dokkioTagFragment';
import integrationItemFragment from './integrationItemFragment';

export const starredObjectFragment = gql`
  fragment starredObjectFragment on StarredObject {
    dokkioClass
    id
    dokkioTagID
    integrationID
    conversation {
      ...conversationFragment
    }
    dokkioTag {
      ...dokkioTagFragment
    }
    integrationItem {
      ...integrationItemFragment
    }
  }
  ${conversationFragment}
  ${dokkioTagFragment}
  ${integrationItemFragment}
`;
export default starredObjectFragment;
